import $x from '@/utils/$x';

/**  商家管理 **/

/// 绑定用户
export async function userData(params) {
  return $x.post('/tenant/statistic/queryTenantUserData', params);
}

export async function coachData(params) {
  return $x.post('/tenant/statistic/tenantUserCompleteClassStatistic', params);
}

export async function dayData(params) {
  return $x.post(
    '/tenant/statistic/tenantUserCompleteClassStatisticByDay',
    params,
  );
}

export async function performanceList(params) {
  return $x.post('/tenant/performance/list', params);
}

export async function performanceUser(params) {
  return $x.post('/tenant/performance/user', params);
}

/// 新增教练
export async function addCoach(params) {
  return $x.post('/tenant/statistic/addCoach', params);
}
/// 删除教练
export async function delCoach(params) {
  return $x.post('/tenant/statistic/delCoach', params);
}
/// 教练数据统计
export async function staticByWeek(params) {
  return $x.post('/tenant/statistic/staticByWeek', params);
}
/// 续费率
export async function renewRate(params) {
  return $x.post('/tenant/statistic/renewRate', params);
}

// 商家看板
export async function tenantBoard(params) {
  return $x.post('/tenant/statistic/tenantBoard', params);
}
